// Axios hatasından kullanıcıya gösterilecek mesajı üretir.
// Backend'in { message } sözleşmesi önceliklidir; ASP.NET ProblemDetails
// (örn. 400 model binding hatası) durumunda `title` alanına düşer.
// HTTP kodu teşhisi kolaylaştırmak için mesaja eklenir.
export const apiErrorMessage = (err, fallback = 'İşlem başarısız.') => {
  const status = err?.response?.status;
  const detail = err?.response?.data?.message
    || err?.response?.data?.title
    || err?.message;
  return [fallback, status ? `(HTTP ${status})` : null, detail]
    .filter(Boolean)
    .join(' ');
};
